/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type AutomatedActionsContainer_settings = {
    readonly integrations: {
        readonly perspective: {
            readonly threshold: number | null;
        };
        readonly external: {
            readonly phases: ReadonlyArray<{
                readonly name: string;
            }>;
        } | null;
    };
    readonly " $refType": "AutomatedActionsContainer_settings";
};
export type AutomatedActionsContainer_settings$data = AutomatedActionsContainer_settings;
export type AutomatedActionsContainer_settings$key = {
    readonly " $data"?: AutomatedActionsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AutomatedActionsContainer_settings">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutomatedActionsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ExternalIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "PerspectiveExternalIntegration",
                    "kind": "LinkedField",
                    "name": "perspective",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "threshold",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomExternalIntegration",
                    "kind": "LinkedField",
                    "name": "external",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalModerationPhase",
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '11f9f21e7b1f0eadb0b679fef845e95b';
export default node;
